import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchWorkTicketWithFilters,} from './store/slice';
import { fetchCustomers } from '../../core/redux/customer/slice';
import { actions as workTicketActions } from './store/slice';
import WorkTicketModals from './work-ticket-modals';
import WorkTicketContent from './work-ticket-content';
import WorkTicketTopHead from './work-ticket-top-head';

const { resetFilters } = workTicketActions;

const WorkTicketView = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchWorkTicketWithFilters());
    dispatch(fetchCustomers({}));
    return () => dispatch(resetFilters());
  }, []);
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Work Ticket</h4>
              </div>
            </div>
            <WorkTicketTopHead />
          </div>
          <WorkTicketContent />
          <WorkTicketModals />
        </div>
      </div>
    </div>
  );
};

export default WorkTicketView;
